import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../fl-components/Iconify';
import palette from '../theme/palette';
import RupeeIcon from '../svg/RupeeIcon';
import { DisplayTimeOfClass } from './ClassTimeTable';
import Modal from './common/Modal';

function LabelText({ text }) {
  return (
    <Typography
      textTransform="uppercase"
      fontSize="14px"
      color={palette.grey[500]}
      mb="5px"
      fontWeight="bold"
    >
      {text}
    </Typography>
  );
}

LabelText.propTypes = {
  text: PropTypes.string
};

function ValueText({ text }) {
  return (
    <Typography textTransform="capitalize" lineHeight={1.5} fontSize="18px">
      {text}
    </Typography>
  );
}

ValueText.propTypes = {
  text: PropTypes.string
};

export default function ClassDetailModal({ isOpen, handleClose, classDetails }) {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      title={classDetails?.name ?? classDetails?.classId?.name}
    >
      <Box mb={2}>
        <LabelText text="Subject" />
        <Stack direction="row" spacing={1} alignItems="center">
          <Iconify icon="bx:book-bookmark" color={palette.secondary.main} />
          <ValueText text={classDetails.subject ?? classDetails?.classId?.subject} />
        </Stack>
      </Box>
      {(classDetails?.description || classDetails?.classId?.description) && (
        <Box mb={2}>
          <LabelText text="About Class" />
          <Stack direction="row" spacing={1} alignItems="center">
            <Iconify icon="ant-design:info-circle-outlined" color={palette.secondary.main} />
            <ValueText text={classDetails?.description || classDetails?.classId?.description} />
          </Stack>
        </Box>
      )}

      <Box mb={2}>
        <LabelText text="Class type" />
        <Stack direction="row" spacing={1} alignItems="center">
          <RupeeIcon color={palette.secondary.main} />
          <ValueText
            text={
              classDetails?.category
                ? `${classDetails.category} - ${classDetails.type}`
                : `${classDetails.classId.category} - ${classDetails.classId.type}`
            }
          />
        </Stack>
      </Box>
      {(classDetails?.schedule || classDetails?.classId?.schedule) && (
        <Box mb={2}>
          <LabelText text="Class time" />
          <Stack direction="row" spacing={1} alignItems="center">
            {/* <Iconify icon="eva:clock-outline" /> */}
            <Stack>
              <DisplayTimeOfClass
                schedule={classDetails?.schedule ?? classDetails?.classId?.schedule}
              />
            </Stack>
          </Stack>
        </Box>
      )}
    </Modal>
  );
}

ClassDetailModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  classDetails: PropTypes.shape({
    name: PropTypes.string,
    subject: PropTypes.string,
    description: PropTypes.string,
    schedule: PropTypes.arrayOf(),
    category: PropTypes.string,
    type: PropTypes.string,
    classId: PropTypes.shape({
      name: PropTypes.string,
      subject: PropTypes.string,
      description: PropTypes.string,
      schedule: PropTypes.arrayOf(),
      category: PropTypes.string,
      type: PropTypes.string
    })
  })
};
